export { Trainings } from "./Trainings";
